package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class OrderItem(
    @SerialName("sku") val sku: String,
    @SerialName("type") val type: String,
    @SerialName("name") val name: String,
    @SerialName("signatureRequired") val signatureRequired: Boolean,
    @SerialName("quantity") val quantity: Float,
    @SerialName("price") val price: Float,
    @SerialName("savings") val savings: Float,
    @SerialName("total") val total: Float,
    @SerialName("discount") val discount: Float,
    @SerialName("promo") val promo: Float,
    @SerialName("tax") val tax: Float,
    @SerialName("recyclingFee") val recyclingFee: Float,
    @SerialName("subtotal") val subtotal: Float,
    @SerialName("freeShipping") val freeShipping: Boolean,
    @SerialName("promotionalMessage") val promotionalMessage: String?,
    @SerialName("externalId") val externalId: String,
    @SerialName("url") val url: String,
    @SerialName("states") val states: List<OrderState>?,
    @SerialName("images") val images: List<OrderImage>?,
)

@Serializable
@JsExport
data class OrderImage(
    @SerialName("tag") val tag: String,
    @SerialName("url") val url: String,
)

@Serializable
@JsExport
data class OrderState(
    @SerialName("name") val name: String,
    @SerialName("quantity") val quantity: Float,
    @SerialName("total") val total: Float,
    @SerialName("userState") val userState: String,
    @SerialName("shipments") val shipments: List<OrderShipment>?,
)

@Serializable
@JsExport
data class OrderShipment(
    @SerialName("shipperName") val shipperName: String,
    @SerialName("trackingNumber") val trackingNumber: String,
    @SerialName("trackingUrl") val trackingUrl: String,
)
